document.addEventListener("DOMContentLoaded", function () {
  let st_searchIcon = document.querySelectorAll(".st-search-icon");
  let st_searchCrossIcon = document.querySelectorAll(".st-input-close-btn");
  let st_searchBoxDesktop = document.querySelector(
    ".st-search-box.hidden-mobile"
  );
  let st_searchBoxMobile = document.querySelector(
    ".st-search-box.hidden-desktop"
  );
  let st_searchInputBoxMobile = document.getElementById("st-search-mobile");
  let st_searchInputBoxDesktop = document.getElementById("st-search");
  let isSearchBoxVisible = false;
  if (st_searchIcon)
    st_searchIcon.forEach((x) => {
      x.addEventListener("click", (e) => {
        if (st_searchBoxDesktop)
          st_searchBoxDesktop.style.display = isSearchBoxVisible ? "none" : "";
        console.log(st_searchBoxMobile);
        setTimeout(() => {
          if (st_searchInputBoxDesktop)
            document.getElementById("st-search").focus();
        }, 200);

        if (st_searchBoxMobile)
          st_searchBoxMobile.style.display = isSearchBoxVisible ? "none" : "";
        console.log(st_searchInputBoxMobile);
        isSearchBoxVisible = !isSearchBoxVisible;
        focusAndOpenKeyboard(document.getElementById("st-search-mobile"));
        st_searchIcon.forEach((x) => {
          x.style.display = "none";
        });
        if (st_searchCrossIcon)
          st_searchCrossIcon.forEach((x) => {
            x.style.display = "";
          });
      });
    });
  if (st_searchCrossIcon)
    st_searchCrossIcon.forEach((x) => {
      x.addEventListener("click", (e) => {
        if (st_searchBoxDesktop) st_searchBoxDesktop.style.display = "none";
        if (st_searchBoxMobile) st_searchBoxMobile.style.display = "none";
        isSearchBoxVisible = false;
        if (st_searchIcon) {
          st_searchIcon.forEach((x) => {
            x.style.display = "";
          });
        }
        st_searchCrossIcon.forEach((x) => {
          x.style.display = "none";
        });
      });
    });
  function focusAndOpenKeyboard(el, timeout) {
    if (!timeout) {
      timeout = 100;
    }
    if (el) {
      console.log("HI");
      // Align temp input element approximately where the input element is
      // so the cursor doesn't jump around
      var __tempEl__ = document.createElement("input");
      __tempEl__.style.position = "absolute";
      __tempEl__.style.top = el.offsetTop + 7 + "px";
      __tempEl__.style.left = el.offsetLeft + "px";
      __tempEl__.style.height = 0;
      __tempEl__.style.opacity = 0;
      // Put this temp element as a child of the page <body> and focus on it
      document.body.appendChild(__tempEl__);
      __tempEl__.focus();

      // The keyboard is open. Now do a delayed focus on the target element
      setTimeout(function () {
        console.log("asdf");
        el.setAttribute("autofocus", "autofocus");
        el.focus();
        el.click();
        // Remove the temp element
        document.body.removeChild(__tempEl__);
      }, timeout);
    }
  }
});
